import React, { useContext } from "react";
import TodoList from "../../TodoList/TodoList";
import LearningPathAssignmentsListItem from "./LearningPathAssignmentsListItem";
import UserAssignmentContext from "../../../context/UserAssignmentContext";

/**
 * Gets the list of assignments. If hasSubheaders is true, returns the grouped lists of assignments to
 * be displayed under each subheader.
 */
function getAssignments(assignments) {
  const {
    isStarted,
    onStartAssignment,
    onChangeEnrollment,
    onResumeAssignment
  } = useContext(UserAssignmentContext);

  return assignments.slice(0, 3).map(assignment => {
    return {
      ...assignment,
      item: (
        <LearningPathAssignmentsListItem
          assignment={assignment}
          isStarted={isStarted(assignment)}
          onEnrolledAssignmentClick={onResumeAssignment}
          onStartAssignmentClick={onStartAssignment}
          onChangeEnrollmentClick={onChangeEnrollment}
        />
      )
    };
  });
}

function LearningPathAssignmentsList({ assignments }) {
  const todoItems = getAssignments(assignments);

  return <TodoList todoList={todoItems} />;
}

export default LearningPathAssignmentsList;
